import { createContext } from "react";

export const ClienteContext = createContext()
export const ClienteFormContext = createContext()
export const ClienteReportContext = createContext()